import {
  ChainOfThought,
  ChainOfThoughtContent,
  ChainOfThoughtHeader,
  ChainOfThoughtStep,
} from '@/components/ai-elements/chain-of-thought';
import { Badge } from '@/components/ui/badge';
import { Check, CircleAlert, Loader2 } from 'lucide-react';
import type { SiteActivity } from './use-site-stream';

export function SiteAgentActivity({
  activities,
  connected,
}: { activities: SiteActivity[]; connected: boolean }) {
  const tools = activities.filter((item) => item.id.startsWith('tool-'));
  const completed = tools.filter((item) => item.status === 'complete').length;
  const working = tools.some((item) => item.status === 'active');
  const steps = activities.filter((item) => !item.id.startsWith('tool-'));
  if (tools.length)
    steps.push({
      id: 'edits',
      label: working ? 'Refining your website' : 'Website edits',
      status: tools.some((item) => item.status === 'error')
        ? 'error'
        : working
          ? 'active'
          : 'complete',
    });
  return (
    <div className="rounded-xl border bg-muted/30 p-3">
      <ChainOfThought defaultOpen>
        <ChainOfThoughtHeader className="text-xs font-medium">
          <span className="flex items-center justify-between gap-2">
            Claire’s activity
            <Badge variant="outline" className="gap-1 text-[10px] font-normal">
              <span className="size-1.5 rounded-full bg-primary motion-safe:animate-pulse" />
              {connected ? 'Live' : 'Connecting'}
            </Badge>
          </span>
        </ChainOfThoughtHeader>
        <ChainOfThoughtContent>
          <ChainOfThoughtStep
            icon={Check}
            label="Request received"
            status="complete"
          />
          {steps.length ? (
            steps.map((item) => (
              <ChainOfThoughtStep
                key={item.id}
                icon={
                  item.status === 'complete'
                    ? Check
                    : item.status === 'error'
                      ? CircleAlert
                      : Loader2
                }
                label={item.label}
                description={
                  item.id === 'edits' && completed
                    ? `${completed} design ${completed === 1 ? 'action' : 'actions'} completed`
                    : undefined
                }
                status={item.status === 'active' ? 'active' : 'complete'}
                className={
                  item.status === 'error'
                    ? 'text-destructive'
                    : item.status === 'active'
                      ? '[&_svg]:motion-safe:animate-spin'
                      : undefined
                }
              />
            ))
          ) : (
            <ChainOfThoughtStep
              icon={Loader2}
              label="Preparing your changes"
              status="active"
            />
          )}
        </ChainOfThoughtContent>
      </ChainOfThought>
    </div>
  );
}
